// extracted by mini-css-extract-plugin
module.exports = {"root":"noAuthorized_root__1xZuK","wrapper":"noAuthorized_wrapper__3nVFs","version":"noAuthorized_version__37EFs","forget":"noAuthorized_forget__c6hcq"};